module.exports = __webpack_public_path__ + "static/img/15.d684a3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/15.jpg
// module id = /NVf
// module chunks = 1